module.exports = __webpack_public_path__ + "img/item-list1.fb5065bb.png";